const CLASS = "incluway-big-cursor";
const STYLE_ID = "incluway-big-cursor-style";
const SHADOW_STYLE_ID = "incluway-big-cursor-shadow-style";

const BIG_ARROW_CURSOR_URL =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1tb3VzZS1wb2ludGVyMi1pY29uIGx1Y2lkZS1tb3VzZS1wb2ludGVyLTIiPjxwYXRoIGQ9Ik00LjAzNyA0LjY4OGEuNDk1LjQ5NSAwIDAgMSAuNjUxLS42NTFsMTYgNi41YS41LjUgMCAwIDEtLjA2My45NDdsLTYuMTI0IDEuNThhMiAyIDAgMCAwLTEuNDM4IDEuNDM1bC0xLjU3OSA2LjEyNmEuNS41IDAgMCAxLS45NDcuMDYzeiIvPjwvc3ZnPg==";

const BIG_POINTER_CURSOR_URL =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1wb2ludGVyLWljb24gbHVjaWRlLXBvaW50ZXIiPjxwYXRoIGQ9Ik0yMiAxNGE4IDggMCAwIDEtOCA4Ii8+PHBhdGggZD0iTTE4IDExdi0xYTIgMiAwIDAgMC0yLTJhMiAyIDAgMCAwLTIgMiIvPjxwYXRoIGQ9Ik0xNCAxMFY5YTIgMiAwIDAgMC0yLTJhMiAyIDAgMCAwLTIgMnYxIi8+PHBhdGggZD0iTTEwIDkuNVY0YTIgMiAwIDAgMC0yLTJhMiAyIDAgMCAwLTItMnYxMCIvPjxwYXRoIGQ9Ik0xOCAxMWEyIDIgMCAxIDEgNCAwdjNhOCA4IDAgMCAxLTggOGgtMmMtMi44IDAtNC41LS44Ni01Ljk5LTIuMzRsLTMuNi0zLjZhMiAyIDAgMCAxIDIuODMtMi44Mkw3IDE1Ii8+PC9zdmc+";

const BIG_TEXT_CURSOR_URL =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS10ZXh0LWN1cnNvci1pY29uIGx1Y2lkZS10ZXh0LWN1cnNvciI+PHBhdGggZD0iTTE3IDIyaC0xYTQgNCAwIDAgMS00LTRWNmE0IDQgMCAwIDEgNC00aDEiLz48cGF0aCBkPSJNNyAyMmgxYTQgNCAwIDAgMCA0LTR2LTEiLz48cGF0aCBkPSJNNyAyaDFhNCA0IDAgMCAxIDQgNHYxIi8+PC9zdmc+";

const ARROW_HOTSPOT = "2 2";
const POINTER_HOTSPOT = "12 6";
const TEXT_HOTSPOT = "16 24";

function upsertStyleTag(
  id: string,
  css: string,
  parent: Document | ShadowRoot = document,
) {
  const existing =
    parent instanceof Document
      ? (parent.getElementById(id) as HTMLStyleElement | null)
      : (parent.querySelector(`#${id}`) as HTMLStyleElement | null);

  if (existing) {
    existing.textContent = css;
    return;
  }

  const style = document.createElement("style");
  style.id = id;
  style.textContent = css;

  if (parent instanceof Document) {
    parent.head.appendChild(style);
  } else {
    parent.appendChild(style);
  }
}

function removeStyleTag(id: string, parent: Document | ShadowRoot = document) {
  if (parent instanceof Document) {
    parent.getElementById(id)?.remove();
    return;
  }

  parent.querySelector(`#${id}`)?.remove();
}

function getWidgetShadowRoot(): ShadowRoot | null {
  return document.getElementById("incluway-widget-root")?.shadowRoot ?? null;
}

function buildCss(scope = `html.${CLASS}`) {
  return `
${scope} {
  cursor: url("${BIG_ARROW_CURSOR_URL}") ${ARROW_HOTSPOT}, auto !important;
}

${scope} body,
${scope} * {
  cursor: url("${BIG_ARROW_CURSOR_URL}") ${ARROW_HOTSPOT}, auto !important;
}

${scope} a[href],
${scope} button,
${scope} input[type="button"],
${scope} input[type="submit"],
${scope} input[type="reset"],
${scope} input[type="checkbox"],
${scope} input[type="radio"],
${scope} select,
${scope} summary,
${scope} [role="button"],
${scope} [onclick] {
  cursor: url("${BIG_POINTER_CURSOR_URL}") ${POINTER_HOTSPOT}, pointer !important;
}

${scope} input[type="text"],
${scope} input[type="email"],
${scope} input[type="search"],
${scope} input[type="url"],
${scope} input[type="password"],
${scope} input[type="tel"],
${scope} input[type="number"],
${scope} textarea,
${scope} [contenteditable="true"] {
  cursor: url("${BIG_TEXT_CURSOR_URL}") ${TEXT_HOTSPOT}, text !important;
}
`.trim();
}

function buildShadowCss() {
  return `
:host, * {
  cursor: url("${BIG_ARROW_CURSOR_URL}") ${ARROW_HOTSPOT}, auto !important;
}

a[href],
button,
input[type="button"],
input[type="submit"],
input[type="reset"],
input[type="checkbox"],
input[type="radio"],
select,
summary,
[role="button"],
[onclick] {
  cursor: url("${BIG_POINTER_CURSOR_URL}") ${POINTER_HOTSPOT}, pointer !important;
}

input[type="text"],
input[type="email"],
input[type="search"],
input[type="url"],
input[type="password"],
input[type="tel"],
input[type="number"],
textarea,
[contenteditable="true"] {
  cursor: url("${BIG_TEXT_CURSOR_URL}") ${TEXT_HOTSPOT}, text !important;
}
`.trim();
}

export function enableBiggerCursor() {
  document.documentElement.classList.add(CLASS);
  upsertStyleTag(STYLE_ID, buildCss());

  const shadowRoot = getWidgetShadowRoot();
  if (shadowRoot) {
    upsertStyleTag(SHADOW_STYLE_ID, buildShadowCss(), shadowRoot);
  }
}

export function disableBiggerCursor() {
  document.documentElement.classList.remove(CLASS);
  removeStyleTag(STYLE_ID);

  const shadowRoot = getWidgetShadowRoot();
  if (shadowRoot) {
    removeStyleTag(SHADOW_STYLE_ID, shadowRoot);
  }
}
